module.exports = __webpack_public_path__ + "img/cloud-lightning.4db77fb2.svg";